// extracted by css-extract-rspack-plugin
export default {"container":"LabelPreview-module__container__ZhssQ"};